import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import Select from '../select/Select';
import FormInput from '../input/FormInput';
import CompoundSubtraction from '../input/compound/CompoundSubtraction';
import Mirror from './Mirror';
import { Grid } from '@mui/material';

const DropoffTypeVolume = ({ props }) => {
    const { getValues, setValue, watch } = useFormContext();

    useEffect(() => {
        const dropoff_type = getValues('dropoff_type');
        // if dropoff_type exists, do not need to set it
        if (!!dropoff_type) return;

        const [scale_weight, metered] = getValues(['scale_weight', 'metered']);
        if (scale_weight) {
            // if scale_weight exists, set dropoff type to scaled
            setValue('dropoff_type', 'scaled');
        } else if (metered) {
            // if scale_weight does not exist but a metered value does, set dropoff type to metered
            setValue('dropoff_type', 'metered');
        }
    }, []);

    const dropoff_type = watch('dropoff_type');

    return (
        <>
            <Select name="dropoff_type" props={props.dropoff_type} />
            <Grid container spacing={1}>
                {dropoff_type === 'metered' ? (
                    // wrap
                    <Grid item xs={12}>
                        <FormInput name="metered" props={props.metered_metered} />
                    </Grid>
                ) : (
                    <>
                        <Grid item xs={12}>
                            <FormInput name="scale_weight" props={props.scale_weight} />
                        </Grid>
                        <Grid item xs={12}>
                            <FormInput name="tare_weight" props={props.tare_weight} />
                        </Grid>
                        <Grid item xs={12}>
                            <CompoundSubtraction name="metered" props={props.scaled_metered} references={['scale_weight', 'tare_weight']} />
                        </Grid>
                        {props.scale_ticket && (
                            <Grid item xs={12}>
                                <FormInput name="scale_ticket" props={props.scale_ticket} />
                            </Grid>
                        )}
                        <Mirror name="net_weight" props={{ type: 'hidden' }} reference={{ referenceField: 'metered' }} />
                    </>
                )}
            </Grid>
        </>
    );
};

export default DropoffTypeVolume;
